// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-drag-li[data-v-6625991c] {\n  display: flex;\n  justify-content: space-between;\n}\n.ui-drag-li .main-content[data-v-6625991c] {\n  display: flex;\n  align-items: center;\n  column-gap: 16px;\n}\n.ui-drag-li .main-content > img[data-v-6625991c] {\n  min-width: 100px;\n}\n.ui-drag-li .index[data-v-6625991c] {\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
